import { useAppContext } from "contexts/AppContext";
import CurrencyFormat from "react-currency-format";

const DefaultCurrency = ({
  value,
  displayType = "text",
  thousandSeparator = true,
  prefix = null,
  decimalScale = 2,
  fixedDecimalScale = true,
}) => {
  const { appState } = useAppContext();

  if(value === null || value === undefined){
    return "-"
  }

  return (
    <CurrencyFormat
      value={value || 0}
      displayType={displayType}
      thousandSeparator={thousandSeparator}
      prefix={
        prefix ||
        appState.auth?.user?.entity?.config?.defaultCurrency?.symbol ||
        "$"
      }
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
    />
  );
};

export default DefaultCurrency;
